import { render, staticRenderFns } from "./searchCopy.vue?vue&type=template&id=75ff1a24&lang=pug&"
import script from "./searchCopy.vue?vue&type=script&lang=js&"
export * from "./searchCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports